export const handleApiError = (error, fallbackMessage) => {
    if (error?.response?.data?.message) {
        return new Error(error.response.data.message);
    }

    if (error?.message) {
        return new Error(error.message);
    }

    return new Error(fallbackMessage);
};